module.exports = __webpack_public_path__ + "img/1545865534.c9d23f09.jpg";